import { render } from "./AlertBars.vue?vue&type=template&id=66cb5afc"
import script from "./AlertBars.vue?vue&type=script&lang=js"
export * from "./AlertBars.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__